import { g as global$1 } from './index.esm-7182addc.js';

const debounce = (func, wait) => {
    let timeout;
    return function () {
        const later = () => {
            timeout = undefined;
            func();
        };
        clearTimeout(timeout);
        timeout = global$1.window.setTimeout(later, wait);
    };
};

export { debounce as d };

//# sourceMappingURL=debounce-9f9e988a.js.map